/*
Copyright 2022-2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { accountDisplayName } from "./auth/accountLogin";
import { type FC, useCallback, useState } from "react";

import { useClientLegacy } from "./ClientContext";
import { useProfile } from "./profile/useProfile";
import { defaultSettingsTab, SettingsModal } from "./settings/SettingsModal";
import { UserMenu } from "./UserMenu";

interface Props {
  preventNavigation?: boolean;
}

export const UserMenuContainer: FC<Props> = ({ preventNavigation = false }) => {
  const { client, logout, authenticated } = useClientLegacy();
  const { displayName, avatarUrl } = useProfile(client);
  const [settingsModalOpen, setSettingsModalOpen] = useState(false);

  const onDismissSettingsModal = useCallback(() => {
    setSettingsModalOpen(false);
    // ❗️ ЖЕЛЕЗОБЕТОННЫЙ ФИКС БЛОКИРОВКИ ИНТЕРФЕЙСА
    // Принудительно убираем pointer-events: none, который оставляет библиотека модалок
    setTimeout(() => {
      document.body.style.pointerEvents = "auto";
    }, 100);
  }, [setSettingsModalOpen]);

  const [settingsTab, setSettingsTab] = useState(defaultSettingsTab);

  const onAction = useCallback(
    (value: string) => {
      switch (value) {
        case "user":
          setSettingsTab("profile");
          setSettingsModalOpen(true);
          break;
        case "settings":
          setSettingsTab("audio");
          setSettingsModalOpen(true);
          break;
        case "logout":
        case "login": // Теперь любая попытка логина через меню тоже делает выход
          logout?.();
          break;
      }
    },
    [logout, setSettingsModalOpen],
  );

  const userName = client?.getUserIdLocalpart() ?? "";
  return (
    <>
      <UserMenu
        preventNavigation={preventNavigation}
        isAuthenticated={authenticated}
        // ❗️ ХАК: Говорим меню, что это полноценный юзер.
        // Теперь вместо Sign In появится нормальная кнопка Sign Out (Выйти).
        isPasswordlessUser={false}
        avatarUrl={avatarUrl}
        onAction={onAction}
        userId={client?.getUserId() ?? ""}
        displayName={accountDisplayName(
          client?.getUserId() ?? "",
          displayName || userName,
        )}
      />
      {client && (
        <SettingsModal
          client={client}
          open={settingsModalOpen}
          onDismiss={onDismissSettingsModal}
          tab={settingsTab}
          onTabChange={setSettingsTab}
        />
      )}
    </>
  );
};
